var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-area jarallax",staticStyle:{"background-image":"url(/img/banner.png)"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }